import axios from "axios";
import React, { useDebugValue, useEffect, useState } from "react";
import {
  Accordion,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
} from "react-bootstrap";
import { HttpJsonHeader } from "../../features/Environments";
import { FormatThaiCard } from "../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";
import { GiAnatomy } from "react-icons/gi";
import StudyItems from "./StudyItems";
import styled from "styled-components";
import { FormControlBlack } from "../components/PageParams";
import { FcPicture } from "react-icons/fc";
import { MdAttachFile } from "react-icons/md";
import { AiOutlinePaperClip } from "react-icons/ai";
import { ConvertDateFromSQL } from "../../core/ThaiDate";
import { StudyReportService } from "../../model/study-report";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";

export default function RadioResultPastCheck(props) {
  const uploadType = { FILE: 1, CAPTURED: 2 };
  const userDetail = props;
  const [showParam, setShowParams] = props.showParam;
  const [item, setItem] = props.selectedItem;

  const [dataX, setDataX] = useState(null);
  const [goods, setGoods] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showParam?.show) {
      getInfo((e) => {
        //console.log("ok");
      });
      return () => {
        setDataX(null);
      };
    }
  }, [showParam?.show]);

  const openLink = (item) => {
    let url = process.env.REACT_APP_API + "/" + item.image_path;
    window.open(url, "_blank", "noreferrer");
  };

  const getInfo = async (callback) => {
    let res = await StudyReportService.GetStudyInfo({
      StudyInfo: item,
      UserInfo: userDetail,
    });

    //console.log("RES", res);

    if (res) {
      let tmp = res;
      setDataX({
        studyInfo: {
          ...res.StudyInfo[0],
          patients_idcard:
            tmp &&
            tmp.StudyInfo[0].patients_idcard &&
            FormatThaiCard(res.StudyInfo[0]?.patients_idcard),
        },
        attachedFile: tmp.StudyFileAttached,
        priceItems: tmp.PriceItems,
        studyResult: tmp.StudyResults,
        studyHistory: tmp.StudyHistory,
      });

      setGoods(tmp.PriceItems);
    }
    callback();
  };
  const handleClose = function (e) {
    setShowParams({ show: false });
  };
  const theme = useSelector((s) => s.theme.theme);
  return (
    <MyModal
      data-theme={theme.themeName}
      style={{ background: theme?.themeName === "light" ? "white" : "#252627" }}
      show={showParam?.show}
      size="xl"
      backdrop={true}
      onHide={handleClose}
      centered
    >
      <ModalHeaderBlack
        backdrop
        closeButton
        style={{ backgroundColor: "#272525" }}
        onHide={() => {
          handleClose();
        }}
      >
        <div
          style={{
            flex: "1",
            color: "#65ee09",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {dataX?.studyInfo?.patients_name}
          {" | เคสวันที่ " + ConvertDateFromSQL(dataX?.studyInfo?.created)}
        </div>
      </ModalHeaderBlack>
      <ModalBodyBlack style={{ margin: "0 0 0 0px", padding: "0 0 0 0px" }}>
        <Accordion defaultActiveKey={["0", "1", "2"]} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <GiAnatomy style={Styles.buttonImage} />
              ส่วนที่ตรวจ-DF
            </Accordion.Header>
            <Accordion.Body style={Styles.accordionBody}>
              <StudyItems {...{ priceData: [goods, setGoods] }} />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            {/* header */}
            <Accordion.Header>
              <MdAttachFile
                style={{ ...Styles.buttonImage, ...{ height: "30px" } }}
              />{" "}
              ไฟล์แนบ - หมายเหตุ - อื่นๆ
            </Accordion.Header>

            <Accordion.Body style={Styles.accordionBody}>
              <VBox
                style={{
                  width: "100%",
                  height: "150px",
                  overflowY: "scroll",
                }}
              >
                {/* List of attached files .. */}
                <HBox>
                  <FileListBox>
                    {dataX &&
                      dataX.attachedFile &&
                      dataX.attachedFile.map((item, i) => {
                        switch (item.upload_type) {
                          case uploadType.FILE: //1
                            return (
                              <ImageLinkButton
                                key={i}
                                onClick={() => openLink(item)}
                              >
                                <AiOutlinePaperClip
                                  style={Styles.fileAttachIcon}
                                />
                                {`${item.image_name}`}
                              </ImageLinkButton>
                            );
                          case uploadType.CAPTURED: //2
                            return (
                              <ImageLinkButton
                                key={i}
                                onClick={() => openLink(item)}
                              >
                                <FcPicture style={Styles.fileAttachIcon} />
                                {`${item.image_name}`}
                              </ImageLinkButton>
                            );
                          default:
                            return (
                              <ImageLinkButton
                                key={i}
                                onClick={() => openLink(item)}
                              />
                            );
                        }
                      })}
                  </FileListBox>
                </HBox>

                {/* หมายเหตุ  */}
                {dataX && dataX.studyInfo ? (
                  <div
                    style={{
                      display: "flex",
                      color: "var(--for-secondary)",
                      flexDirection: "column",
                      marginInline: "5px",
                      flex: "1",
                    }}
                  >
                    <div
                      style={{
                        paddingLeft: "15px",
                        borderBottom: "solid 1px var(--date-border)",
                      }}
                    >
                      หมายเหตุ:
                    </div>
                    <FormControlBlack
                      readOnly
                      as="textarea"
                      style={{ flex: "1", paddingLeft: "15px" }}
                      // rows={5}
                      value={dataX.studyInfo?.study_remark}
                    ></FormControlBlack>
                  </div>
                ) : (
                  <></>
                )}
              </VBox>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <div
          style={{
            background: "var(--bg-primary)",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "5px",
            borderRadius: "2px",
            color: "var(--fore-primary)",
            // boxShadow: "5px 5px 10px 0px #999999",
          }}
        >
          <Form.Control
            style={{
              fontFamily: "Times New Roman",
              background: "var(--bg-primary)",
              color: "var(--fore-primary)",
            }}
            as="textarea"
            rows={20}
            value={dataX?.studyResult[0]?.result_text}
          ></Form.Control>
        </div>
      </ModalBodyBlack>
    </MyModal>
  );
}

const Styles = {
  accordionBody: { background: "var(-bg-primary)", padding: "0 0 0 0px" },
  buttonTemplate: { marginRight: "5px" },
  buttonImage: {
    // marginInline: "10px",
    marginTop: "5px",
    marginBottom: "5px",
    color: "var(--fore-primary)",
    height: "30px",
    width: "40px",
  },
  buttonImageBig: {
    marginRight: "5px",
    color: "var(--fore-primary)",
    height: "40px",
    width: "40px",
  },
  innerIconButton: { marginTop: "-5px" },
  fileAttachIcon: {
    color: "var(--fore-primary)",
    marginInline: "5px",
  },
};

const ImageLinkButton = styled.div`
  text-decoration: none;
  color: var(--fore-primary);
  cursor: pointer;
  padding: 2px;
  margin: 1px 5px 1px 5px;
  transition: 100ms;
  font-size: 13px;
  word-break: break-word; // break-all;
  :hover {
    transition: 2s;
    text-decoration: none;
    color: #08e75e;
  }
`;

const HBox = styled.div`
  display: flex;
  flex: 1;
`;

const VBox = styled.div``;

const FileListBox = styled.p`
  padding: 10px 1px 10px 5px;
  color: white;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  justify-content: "space-between";
`;
